import { Box, Image, Text } from "@chakra-ui/react";
import { useContaxt } from "../../context/Context";
import image2 from "../../images/webentwickler_erklärt_vertriebler_ein_webdesign.webp";
import image1 from "../../images/webentwickler_und_vertriebler_besprechen_webdesign.webp";
import { HeadLine } from "../HeadLine";
import { AboutText } from "./AboutText";

export function About() {
  const { marginTop } = useContaxt();
  const { variant } = useContaxt();

  return (
    <>
      <Box w={"100%"} px={3}>
        <HeadLine
          as="h1"
          text={
            <Text
              fontSize={["25px", "35px", "32px", "35px", "45px"]}
              fontWeight={"extrabold"}
            >
              Über uns
            </Text>
          }
        />
        <AboutText
          marginT={marginTop}
          textWidth={variant === "lg" ? "550px" : "100%"}
          side={"left"}
          image={
            <Image
              src={image2}
              w="100%"
              h="100%"
              maxWidth={variant === "lg" ? "540px" : "100%"}
              borderRadius={"25px"}
              objectFit="cover"
              display="block"
              alt={
                "Der Webentwickler & Webdesigner Lukas bespricht mit dem Vertriebler David ein aktuelles Webdesign Projekt"
              }
              title="Webseiten besprechung eines Kunden"
              loading="lazy"
              decoding="async"
            />
          }
          text={
            <Text>
              Mein Name ist Lukas Körber. Ich bin 24 Jahre alt und studierter
              Wirtschaftsinformatiker in Kiel
              <br /> <br />
              Mit dem Programmieren habe ich im jungen Alter von 12 Jahren
              angefangen und mich sofort darin verliebt. Seitdem ist es meine
              Leidenschaft und aus meinem Leben nicht mehr wegzudenken. Während
              meiner Schulzeit entwickelte ich ein großes Interesse an
              Wirtschaft und entschied mich nach dem Abitur für ein Studium der
              Wirtschaftsinformatik in Kiel
              <br />
              <br />
              Während des Studiums baute ich meine Fähigkeiten im Bereich der
              Webentwicklung weiter aus und erlernte viele Fertigkeiten, die mir
              heute bei meiner täglichen Arbeit helfen, die Wünsche meiner
              Kunden zu erfüllen.
            </Text>
          }
        />

        <AboutText
          textWidth={variant === "lg" ? "550px" : "100%"}
          side={"right"}
          image={
            <Image
              src={image1}
              w="100%"
              h="100%"
              maxWidth={variant === "lg" ? "540px" : "100%"}
              objectFit={"cover"}
              borderRadius={"25px"}
              loading={"lazy"}
              alt={
                "Der Webentwickler & Webdesigner Lukas zeigt dem Vertriebler David ein aktuelles Webdesign Projekt"
              }
              title="Besprechung eines Webseiten Projektes"
            />
          }
          text={
            <Text>
              Seit 2017 bin ich als Webdesigner in Kiel tätig und unterstütze
              mit meinem Team Unternehmen dabei, ihre Sichtbarkeit zu erhöhen,
              ihre Zielgruppe anzusprechen und sich durch maßgeschneiderte
              Lösungen - insbesondere im Bereich Webdesign - von der Konkurrenz
              abzuheben.
              <br />
              <br />
              Mein Team und ich setzen bei unserer Arbeit auf individuelle
              Konzepte, die den Bedürfnissen und Anforderungen unserer Kunden
              entsprechen. Dank unserer langjährigen Erfahrung konnten wir
              bereits zahlreiche Projekte erfolgreich umsetzen und die Ziele
              unserer Kunden erreichen.
              <br />
              <br />
              Wir verzichten bewusst auf den Einsatz von Content Management
              Systemen wie WordPress, da diese Plattformen oft nicht den hohen
              Ansprüchen genügen, die wir an unsere Arbeit stellen. Stattdessen
              streben wir danach, dass sich unsere Kunden mit dem Endprodukt
              identifizieren können und ihre Ziele mit einer maßgeschneiderten
              Lösung erreichen - fernab von standardisierten Webseiten.
            </Text>
          }
        />
      </Box>
    </>
  );
}
